import { Directive, Input, OnChanges, TemplateRef, ViewContainerRef, inject } from '@angular/core';
import { Permission } from 'src/app/common/enums/permissions';
import { PermissionService } from '../services/permission.service';

@Directive({
  selector: '[ifHasPermissions]',
  standalone: false
})
export class IfHasPermissionsDirective implements OnChanges {
  private view = inject(ViewContainerRef);
  private template = inject<TemplateRef<any>>(TemplateRef);
  private permissionService = inject(PermissionService);

  @Input('ifHasPermissions') permissions: Permission[];

  constructor() { }

  ngOnChanges(): void {
    if (this.permissions && this.permissionService.hasPermissions(...this.permissions)) {
      this.view.createEmbeddedView(this.template);
    } else {
      this.view.clear();
    }
  }
}
